// GrindCTRL market-mismatch banner.
// Detects when a visitor's actual country differs from the market they're
// currently browsing, and offers a quiet way to switch. Never blocks access —
// GeoIP isn't reliable enough (VPNs, etc.) to gate content on it.

(function () {
  var DISMISS_KEY = 'gc-market-banner-dismissed';

  // ponytail: only the markets this store actually has. Add here if more launch.
  var STORE_NAMES = { EG: 'Egypt', SA: 'Saudi Arabia' };

  function storeName(code) {
    return STORE_NAMES[code] || code;
  }

  function submitLocalization(country, language) {
    var form = document.createElement('form');
    // Must be market-scoped: on a subfolder market the endpoint is
    // /en-sa/localization, not the primary market's /localization.
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    form.action = root.replace(/\/$/, '') + '/localization';
    form.method = 'POST';
    form.hidden = true;
    form.innerHTML =
      '<input name="_method" value="PUT">' +
      '<input name="country_code" value="' + country + '">' +
      (language ? '<input name="language_code" value="' + language + '">' : '');
    document.body.appendChild(form);
    form.submit();
  }

  class GcMarketBanner extends HTMLElement {
    connectedCallback() {
      if (sessionStorage.getItem(DISMISS_KEY)) return;
      if (!window.Shopify || !window.Shopify.country) return;

      var currentCountry = window.Shopify.country;
      var currentLanguage = window.Shopify.language;

      fetch(
        window.Shopify.routes.root +
          'browsing_context_suggestions.json' +
          '?country[enabled]=true&country[exclude]=' + encodeURIComponent(currentCountry) +
          '&language[enabled]=true&language[exclude]=' + encodeURIComponent(currentLanguage)
      )
        .then(function (r) { return r.ok ? r.json() : null; })
        .then((data) => {
          if (!data || !data.suggestions || !data.suggestions.length) return;
          var suggestion = data.suggestions[0];
          var suggestedCountry = suggestion.parts && suggestion.parts.country && suggestion.parts.country.handle;
          if (!suggestedCountry || suggestedCountry === currentCountry) return;
          var suggestedLanguage = suggestion.parts && suggestion.parts.language && suggestion.parts.language.handle;
          this.render(currentCountry, suggestedCountry, suggestedLanguage);
        })
        .catch(function () { /* silent: banner just doesn't show */ });
    }

    render(currentCountry, suggestedCountry, suggestedLanguage) {
      this.innerHTML =
        '<p class="gc-mb__text">You’re browsing the ' + storeName(currentCountry) +
        ' store. Switch to ' + storeName(suggestedCountry) + '?</p>' +
        '<div class="gc-mb__actions">' +
        '<button type="button" class="gc-mb__btn gc-mb__btn--primary" data-gc-switch>Switch to ' + storeName(suggestedCountry) + '</button>' +
        '<button type="button" class="gc-mb__btn" data-gc-stay>Stay here</button>' +
        '</div>' +
        '<button type="button" class="gc-mb__x" data-gc-stay aria-label="Dismiss">×</button>';

      this.removeAttribute('hidden');
      requestAnimationFrame(() => this.classList.add('is-open'));

      this.querySelector('[data-gc-switch]').addEventListener('click', function () {
        submitLocalization(suggestedCountry, suggestedLanguage);
      });

      this.querySelectorAll('[data-gc-stay]').forEach((btn) => {
        btn.addEventListener('click', () => {
          sessionStorage.setItem(DISMISS_KEY, '1');
          this.classList.remove('is-open');
          setTimeout(() => this.setAttribute('hidden', ''), 300);
        });
      });
    }
  }

  customElements.define('gc-market-banner', GcMarketBanner);
})();
